(function() {
  'use strict';

  angular.module('component.roles', []);
})();
